import React from 'react'
import { useSelector } from 'react-redux'
import useStickyHeader from './useStickyHeader'

export default function HeaderApp ({ children }) {
  const shouldRender = useSelector((state) => (
    state.app.get('renderHeader', true)
  ))
  // App-wide sticky header: pin `#header-app` whenever the header is rendered
  // (publishes `--app-sticky-header-offset` + the `--scrolled` variant).
  useStickyHeader(shouldRender)
  return shouldRender ? (
    <div id="header-app">
      <div className="header-app">
        {children}
      </div>
    </div>
  ) : null
}
